<template>
    <div class="analysis-complex">   
        <div @click="save_pic"  class="down-img">
            <div  class="down"></div>
        </div>
        <div :id="containerId"  class="container complex-d3DIV"></div>
    </div>
</template>

<script>
// 模拟数据  
import subjectJson from './subjectJson.js' 
import modelTip from "../../../components/ui-kit/model_tip.vue"
import G6 from '@antv/g6'; 
// import { complexData_fx } from '../../../io/api.js'
export default {
    props:['graphList','containerId','complexType'],
    components: {
        modelTip, 
    },
    data () {
        return {         
            graph: null,//初始化
            graphWidth:'',
            graphHeight:'',
            newData:[],  //处理数据用
            // graphList:subjectJson.jsonList, 
            nodeFrom:{
                minWeight:'10',
                limitEdgeCount:'100',
                layCount:3,//层数  
                sorce:1.3,//置信度
                nodeNames:'',//节点过滤
            },
            isNodata:false, 
        }
    },
    watch: {
        
    },
    mounted () {
        this.getData();
        // this.tabClick()
    },
    methods: { 
        initData(){     
            this.isNodata=false;
             
        },
        getData(){ 
            this.initData();  
            this.data_process();
            
        }, 
         //数据处理
         data_process(){ 
            let nodesData=this.graphList &&this.graphList.nodes||[];
            let edgesData=this.graphList &&this.graphList.edges||[]; 
            if(nodesData.length==0){
                this.isNodata = true
                return
            }
            this.newData={
                nodes:[],
                edges:[],
            }
            nodesData&&nodesData.forEach((item,index)=>{ 
                // item.label=item.name;
                this.$set(item,'num',index+1)
                this.newData.nodes.push(item)
            }) 
            edgesData&&edgesData.forEach((item,index)=>{
                // item.label='';
                this.$set(item,'num',index+1)
                this.newData.edges.push(item)
                
            })    
            this.set_nodeStyle(); 
                this.graph_tab();

        }, 
        //初始化图谱
        set_nodeStyle(){
            let _this = this;
            //初始化的节点颜色处理 
            this.newData&&this.newData.nodes.forEach(function (node) { 
                if (!node.style) {
                    node.style = {
                        fill:'#3ba7fa',
                        stroke:'#41e976',
                        lineWidth:2
                    };
                }
                //设置节点颜色
                if(_this.complexType=='curveLPair'){
                    _this.node_fill(node)
                }
                //根据degree，设置节点大小 
                // node.size = node.degree;  
                if(_this.complexType=='group'||_this.complexType=='author'){
                    if(node.degree<3){
                        node.size = 20; 
                    }else if(node.degree>3&&node.degree<10){
                        node.size = node.degree*10; 
                    }else if(node.degree>10){
                        node.size = 120; 
                    } 
                    //_this.node_fill(node)
                }else if(_this.complexType=='keywordPair'||_this.complexType=='curveLPair'){ 
                    if(node.degree<=10){
                        node.size = 10; 
                    }else if(node.degree>10&&node.degree<120){
                        node.size = node.degree;
                    }else if(node.degree>=120){
                        node.size = 120; 
                    }
                }
                // if(node.degree>Number(_this.degreeNum)){
                //     node.size = 40; 
                // }else{
                //     node.size = 20; 
                // }
            });
        },
        //节点的颜色 统一，根据degree设置元素大小
        node_fill(node,type){
            //degree   
           
            // if (node.degree=='中医治则') {
            //     color='#fca3d9'
            // } else if(node.degree=='中医治疗'){
            //     color='#e84dff'
            // } else if(node.degree=='中医疾病'){
            //     color='#c147fa'
            // } else if(node.degree=='中医证候'){
            //     color='#9a80ff'
            // } else if(node.degree=='中医诊断'){
            //     color='#c0c8fd'
            // } else if(node.degree=='中药'){
            //     color='#fdcece'
            // }else if(node.degree=='临床表现'){
            //     color='#3ba7fa'
            // } else if(node.degree=='体格检查'){
            //     color='#60f6fc'
            // } else if(node.degree=='方剂'){
            //     color='#78cea3'
            // } else if(node.degree=='治法'){
            //     color='#96fe82'
            // }else if(node.degree=='症状'){
            //     color='#dafe5c'
            // } else if(node.degree=='穴位'){
            //     color='#fbbd37'
            // } else if(node.degree=='西医治疗'){
            //     color='#fd9526'
            // } else if(node.degree=='西医疾病'){
            //     color='#ff6035'
            // }else if(node.degree=='辅助检查'){
            //     color='#bffaee'
            // }
            node.style.fill = node.distance
            node.style.stroke = node.distance
        },
        //图谱渲染
        graph_tab(val){  
            if (this.graph) this.graph.destroy(); 
            this.graph = new G6.Graph({
                container: this.containerId,
                width:1200,
                height:700, 
                modes: {
                    default: ['zoom-canvas','click-select','drag-canvas', 'drag-node','activate-relations','collapse-expand-combo'],
                },
                layout: {
                    type: val?val:'random',
                    linkDistance:100,
                }, 
                animate: true,
                //节点在默认状态下的样式属性
                defaultNode: { 
                    size:10, 
                    // 节点文字
                    labelCfg: { 
                        position:'center',
                        style:{
                            fontSize:14,
                            // stroke:'#000',
                            lineWidth: 2,
                            fill:'#000',
                        }
                    },
                },  
                nodeStateStyles: {
                    // 无关联的节点置灰
                    inactive: {
                        stroke: '#eee',
                        // lineWidth: 2,
                        opacity:.5,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },
                // 设置边高亮样式
                edgeStateStyles: {
                    highlight: {
                        // fill:'#A5E4F0',
                        // stroke: '#A5E4F0', // 这个颜色可以根据个人喜好进行修改
                        lineWidth:8,//lineWidth?lineWidth:4
                        opacity:1
                    },
                    inactive: {
                        stroke: '#eee',
                        fill: "#eee", 
                        'text-shape': {
                            opacity:0.01 
                        },
                    },
                },
                comboStateStyles: {
                    highlight: { 
                        opacity: 0.7,
                        cursor: "pointer",
                        'text-shape': { 
                            lineWidth: 4,
                        },
                    },
                    inactive: {
                        stroke: '#eee',
                        opacity:1,  
                        lineWidth: 4,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },

                //边在默认状态下的样式属性
                defaultEdge: {
                    labelCfg:{
                        style:{
                            opacity:0,
                            fontSize:16,
                            // fill:'#000',
                        }
                    },
                    style:{
                        opacity:.5, 
                        stroke:'#626161',//边的颜色
                        endArrow: { // 设置终点箭头
                            path: '', // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                            stroke:'#626161 ',
                            fill:'#626161 ', 
                        },
                    },
                    
                    // shape: 'arc',  // 在数据中已经指定 shape，这里无需再次指定
                    curveOffset: -80,
                },
            }); 
            this.graph.data(this.newData);
            this.graph.render(); 
            //边的移入移出
            this.graph.on("edge:mouseenter", (e) => {  
                this.graph.setItemState(e.item, "highlight", true);
                this.edgesOpacity(e.item,1,'hover' )   
            });
            this.graph.on("edge:mouseleave", (e) => { 
                this.graph.setItemState(e.item, "highlight", false);
                this.edgesOpacity(e.item,0 ) 
                
            });  
            this.graph.on('node:mouseenter', this.graph_mouseenter)
            this.graph.on('node:mouseleave', this.graph_mouseleave) 
            setTimeout(() => {
                this.report_pic()
            }, 3000);
        }, 
        //鼠标移入时，设置节点连线高亮
        graph_mouseenter(e){
            let that = this // 改变this指向
            let item = e.item; 
            // 设置是否在更新/删除后自动重绘，一般搭配 paint() 方法使用。
            that.graph.setAutoPaint(false) 
            that.graph.getEdges().forEach(function (edge) { 
                //全部边文字显示
                that.edgesOpacity(edge,1 ,'hover' )    
                //getSource()获取当前边的起始节点。 getTarget获取当前边的终止节点。
                if (edge.getSource() != item && edge.getTarget() != item) {
                    that.edgesOpacity(edge,0,'hover')
                } 
            })
            that.graph.paint()
            that.graph.setAutoPaint(true)
        },
        //清除节点连线高亮状态
        graph_mouseleave () {
            const that = this
            this.graph.setAutoPaint(false)
            //边文字不显示
            this.graph.getEdges().forEach(function (edge) { 

                that.edgesOpacity(edge,0,)
            })
 
            this.graph.paint()
            this.graph.setAutoPaint(true)
        },
        //边laberl的文字透明度
        edgesOpacity(edge,num,type){
            let opacity = num;   
            if(this.sideLabel=='show'){
                opacity=0.5;
                if(type=='hover'){
                    opacity=1
                }
            }else{
                opacity=num;
            }
            this.graph.updateItem(edge, {
                labelCfg: {
                    style: {  
                        opacity,
                    }, 
                }
            }) 
        }, 
        save_pic(){
            window.oldRatio = window.devicePixelRatio
            window.devicePixelRatio = 4
            this.graph.downloadFullImage("网络分析图", 'image/png', {padding:20})
            setTimeout(() => {
                window.devicePixelRatio = window.oldRatio
            }, 100) 
        },
        report_pic(){
            let reportImg='';
            this.graph.toFullDataURL((res)=>{
                reportImg= res; 
                //区分哪个模块调用的author：作者，group：机构，keywordPair：关键词共现 
                this.$emit('comples_img',this.complexType,reportImg)
            }, 'image/png', {padding:20})
        }
    }
}
</script> 
<style lang="less" scoped>
    // @import url('./analysis_details.less');
    .text-tip{
        // display: flex;
        .icon{
            display: inline-block;
            vertical-align: middle;
            width:16px;
            height: 16px;
            border-radius: 50%;
            background: #fdcb02;
        }
    } 
.collapse-info{
    ::v-deep .el-form-item{
        padding-right: 20px;
        .el-slider__stop{
            background: #79bbff;
        }
        
    }
    
   
}
.analysis-complex{
    width: 1200px;
    margin: 0 auto;
    border: 1px dashed #79bbff;
    margin-bottom: 20px;
    .container{
        width: 100%;
        height: 700px;
        margin-bottom: 20px;
    }
    .down-img{
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
        .down{
            width: 16px;
            height: 16px;
            background: url('../../../assets/images/bibliometric/down-img.png') no-repeat;
            background-size: cover;
            cursor: pointer;
        }
        
    }
}
</style>